<div class="row">
  <div class="col-12">
    <p class="text-lead" jhiTranslate="register.form.siretInformation.description"></p>
    <jhi-bary-siret
      [id]="'siret'"
      [control]="siretControl"
      (addressChange)="updateAddress($event)"
      (vatNumberChange)="vatNumberControl.patchValue($event)"
      (companyNameChange)="companyNameControl.patchValue($event)"
    ></jhi-bary-siret>
  </div>
</div>
